import { createContext, useContext, useState } from 'react'

import { useAuthContext } from './AppAuthContext'

const AppErrorContext = createContext<any>(null)

export const AppErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const [appError, setError] = useState<string>('')
  const { setArcanaAcc, setMetamaskAcc, setWeb3Token } = useAuthContext()

  const setAppError = (e: any) => {
    if (typeof e === 'string') {
      setError(() => e)
      return
    }
    if (e?.response?.status === 401) {
      localStorage.removeItem('metamaskAcc')
      setMetamaskAcc('')
      localStorage.removeItem('arcanaAcc')
      setArcanaAcc('')
      localStorage.removeItem('web3token')
      setWeb3Token('')
      setError(() => e.response.data.msg)
      return
    }
    if (e?.response?.data?.msg) {
      setError(() => e?.response?.data?.msg)
      return
    } else {
      console.error(e)
      setError(() => 'Something went wrong...')
    }
  }

  return <AppErrorContext.Provider value={{ appError, setAppError }}>{children}</AppErrorContext.Provider>
}

export const useAppErrorContext = () => useContext<IUseData>(AppErrorContext)

interface IUseData {
  appError: string
  setAppError: (error: any) => void
}
